import { useState, useEffect } from "react";
import { SiteVideoData } from "../../../../interfaces";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { VerticalVideoPlayer } from "../../components/VerticalVideoPlayer";
import { VerticalShareArea } from "../../components/VerticalShareArea";
import { DesignItemProps } from "../../interfaces";
require("./ynet_ynetnews_vesty_site_verticalVideoItem.less");

export const VerticalVideoItem = (props: DesignItemProps) => {
    const { videoItem, index, domain, isMobile, languageCode, showPrerollAds, isTitleVisible, isSubTitleVisible,
        isGalleryView, headerClassName, shouldDisplayArrow, currentPlayingVideo, containerStyle, dynamicHeight, dynamicWidth,
        onNextSlide, onVideoOverlayClose } = props;
    const { itemId, media, title, subTitle, titleLink, titleTargetLink } = videoItem;

    const [isSubtitleOpen, setIsSubtitleOpen] = useState(false);
    const [isVideoStarted, setIsVideoStarted] = useState(false);

    const isVideo = media && (media as any).mediaType === "MEDIA_VIDEO";
    const credit = media ? media.credit || "" : "";
    const videoPageId = isVideo ? (media as SiteVideoData).videoPageId : "";
    const poster = isVideo ? (media as SiteVideoData).poster : "";
    const is_drm = isVideo ? !!(media as SiteVideoData).is_drm : false;

    useEffect(() => {
        if (!is_drm || !poster) return;

        const handlePlaying = () => setIsVideoStarted(true);
        let videoEl: HTMLVideoElement | null = null;
        let timer: number | undefined;

        const tryAttach = () => {
            videoEl = document.querySelector(`#VerticalVideoItem_${itemId} .fp-engine`) as HTMLVideoElement;
            if (videoEl) {
                videoEl.addEventListener("playing", handlePlaying);
                return true;
            }
            return false;
        };

        if (!tryAttach()) {
            timer = window.setInterval(() => {
                if (tryAttach()) window.clearInterval(timer);
            }, 100);
        }

        return () => {
            window.clearInterval(timer);
            if (videoEl) videoEl.removeEventListener("playing", handlePlaying);
        };
    }, [itemId]);

    const lang = languageCode || "";
    const nextVideoLabel = lang.includes("en") ? "next video" : lang.includes("ru") ? "Следующее видео" : "לסרטון הבא";
    const copyLinkLabel = lang.includes("en") ? "copy link" : lang.includes("ru") ? "Скопировать ссылку" : "העתק קישור";
    const linkCopiedLabel = lang.includes("en") ? "Link copied to clipboard" : lang.includes("ru") ? "Ссылка скопирована" : "הקישור הועתק ללוח";
    const readFullArticleLabel = (videoItem && videoItem.text)
        ? videoItem.text
        : (lang.includes("en") ? "Read Full Article" : lang.includes("ru") ? "Читать полную статью" : "לכתבה המלאה");

    const pushItemGA4Event = () => {
        if (typeof window == "undefined" || !window.dataLayer) return;
        window.dataLayer.push({
            event: "content_click",
            componenta_name: "vertical_video",
            content_type: "componenta",
            position_in_component: index,
            click_text: "לכתבה המלאה"
        });
    };

    const verticalItemClass = `vertical-video-item ${isMobile ? isSubtitleOpen ? "openMode" : "standardMode" : ""}`;
    const subtitleClass = `videoSubtitle ${isSubtitleOpen ? "" : "close"}`;

    const showDrmPosterOverlay = is_drm && !!poster && !isVideoStarted;

    return (
        <div className={verticalItemClass} id={`VerticalVideoItem_${itemId}`} style={showDrmPosterOverlay ? { ...containerStyle, position: "relative" } : containerStyle}>
            {showDrmPosterOverlay && (
                <img
                    src={poster}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 0,
                        pointerEvents: "none",
                    }}
                />
            )}
            {isVideo &&
                <VerticalVideoPlayer
                    index={index}
                    itemId={itemId}
                    isMobile={isMobile}
                    onNextSlide={onNextSlide}
                    dynamicWidth={dynamicWidth}
                    dynamicHeight={dynamicHeight}
                    isGalleryView={isGalleryView}
                    media={media as SiteVideoData}
                    showPrerollAds={showPrerollAds}
                    prerollIndex={videoItem.prerollIndex}
                    hidePrerollAds={videoItem.hidePrerollAds}
                    currentPlayingVideo={currentPlayingVideo}
                />
            }

            <div className="contentDiv">
                <div className="videoInfo">
                    <div className="textContent">
                        {isTitleVisible && <div className="videoTitle" dangerouslySetInnerHTML={{ __html: title }} />}

                        {isSubTitleVisible && <div className={subtitleClass} onClick={() => setIsSubtitleOpen(!isSubtitleOpen)} dangerouslySetInnerHTML={{ __html: subTitle }} />}

                        <div className="moreDetails">
                            <div className="credit">{credit}</div>

                            {titleLink &&
                                <div onClick={pushItemGA4Event}>
                                    <HyperLinkBuilder className="videoLink" href={titleLink} linkTarget={titleTargetLink}>
                                        <div className="linkText">{readFullArticleLabel}</div>
                                        <div className="linkIcon"></div>
                                    </HyperLinkBuilder>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="btnsContent">
                        <VerticalShareArea
                            title={title}
                            domain={domain}
                            isMobile={isMobile}
                            videoPageId={videoPageId}
                            shareItemType="verticalVideo"
                            copyLinkLabel={copyLinkLabel}
                            linkCopiedLabel={linkCopiedLabel}
                        />

                        <div className="mute-btn" id="volume-target"></div>
                    </div>
                </div>

                <div className="playerDetails">
                    <div className="timeline" id="timeline-target"></div>

                    <div className="playing-time">
                        <div className="elapsed" id="elapsed-target"></div>
                        /
                        <div className="duration" id="duration-target"></div>
                    </div>

                    {shouldDisplayArrow &&
                        <div className={`arrow arrowNext`} onClick={onNextSlide}>
                            <div className="arrowText">{nextVideoLabel}</div>
                            <div className="arrowIcon"></div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};
